import { render, staticRenderFns } from "./OtherNotifications.vue?vue&type=template&id=49801f53&"
import script from "./OtherNotifications.vue?vue&type=script&lang=js&"
export * from "./OtherNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports